<template>
    <Autosuggest
        :value="value"
        :label="config.PROFILE_ADDRESS_STATE"
        :disabled="disabled"
        :options="filteredStates"
        @input="onInput"
        @select="onSelect"
    />
</template>
<script>
import { State } from 'country-state-city';

import { Autosuggest } from '../lib';
import { SolutionConsumer } from '../../mixins';

export default {
    name: 'StateSelect',
    components: { Autosuggest },
    mixins: [SolutionConsumer],
    props: {
        value: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        country: {
            type: String,
            default: '',
        },
    },
    computed: {
        states () {
            return State.getStatesOfCountry(this.country).map(({ name }) => ({ name }));
        },
        filteredStates () {
            return this.value
                ? this.states.filter(({ name }) => name.toLowerCase().includes(this.value.toLowerCase()))
                : this.states;
        },
    },
    watch: {
        country (country) {
            if (!country) {
                this.onInput('');
            }
        },
    },
    methods: {
        onInput (value) {
            this.$emit('input', value);
        },
        onSelect (option) {
            this.$emit('input', option.name);
        },
    },
};
</script>
